export enum CountryCodes {
  RF = "7",
  KZ = "7",
  BY = "375",
  KG = "996",
  UZ = "998",
  AM = "374",
  MN = "976",
  CN = "86",
}